import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../components/layout";
import { Button, Modal, Select, Tabview } from "../../../../components/core";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  BULK_CREATE_MESSAGE_TEMPLATE,
  CREATE_MESSAGE_TEMPLATE,
  LOCKER_TYPE_FOR_LOCKER_USER_TEMPLATE,
  OPERATOR_MESSAGE_TEMPLATE,
  UPDATE_MESSAGE_TEMPLATE,
} from "../../../../constants/graphql/message-template-queries";
import reactSelect from "react-select";
import TabComponent from "../../../../components/core/tab";
import { Strings } from "../../../../constants/strings";
import { TabviewTemplate } from "../components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useSidebarStore from "../../../../zustand/stores/sidebar-store";
const MESSAGE_MEDIA = ["sms", "app"];
const MESSAGE_GROUP = ["Cleanup Alerts"];
export default function LockerCleanUpTemplate() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const navigate = useNavigate();
  // Local States
  const [lockerTypeList, setLockerTypeList] = React.useState([]);
  const [lockerTypeValue, setLockerTypeValue] = React.useState("-1");
  const [messageGroupValue, setMessageGroupValue] = React.useState(
    MESSAGE_GROUP[0]
  );
  const [editingDone, setEditingDone] = useState(false);
  const [messageTemplateList, setMessageTemplateList] = React.useState([]);
  const [messageTemplateListOriginal, setMessageTemplateListOriginal] =
    React.useState([]);
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [checkedStates, setCheckedStates] = useState(
    messageTemplateList.reduce((acc, item) => {
      acc[item.operatorMessageTypeId] = false; // Initialize each to false
      return acc;
    }, {})
  );
  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  const handleCheckedChange = (id, isChecked) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      [id]: isChecked,
    }));
  };

  // GQL
  const lockerTypes = useQuery(LOCKER_TYPE_FOR_LOCKER_USER_TEMPLATE);
  const [operatorMessageTemplate, { data, loading, value, refetch }] =
    useLazyQuery(OPERATOR_MESSAGE_TEMPLATE);
  const [updateMessageTemplate] = useMutation(UPDATE_MESSAGE_TEMPLATE);
  const [bulkCreateMessageTemplate] = useMutation(BULK_CREATE_MESSAGE_TEMPLATE);
  const [singleCreateMessageTemplate] = useMutation(CREATE_MESSAGE_TEMPLATE);

  // Handle Changes
  const handleChangeLockerTypeValue = (e) => {
    setEditingDone(false);
    setLockerTypeValue(e.target.value);
    operatorMessageTemplate({
      variables: {
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: e.target.value,
        menuGroup: "Locker Cleanup Templates",
        messageGroup: messageGroupValue,
      },
    });
  };
  const handleOnTemplateChange = (event, operatorMessageTypeId) => {
    setEditingDone(true);
    let tempMessageTemplateList = [...messageTemplateList];
    const { name, value } = event.target;
    let index = tempMessageTemplateList.findIndex(
      (x) => x.operatorMessageTypeId === operatorMessageTypeId
    );
    console.log(value);
    tempMessageTemplateList[index][name] = value;
    setMessageTemplateList(tempMessageTemplateList);
  };
  const handleOnTabChanged = (tabValue) => {
    setEditingDone(false);
    setMessageGroupValue(MESSAGE_GROUP[tabValue]);
    refetch({
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerTypeId: lockerTypeValue,
      menuGroup: "Locker Cleanup Templates",
      messageGroup: MESSAGE_GROUP[tabValue],
    });
  };
  const handleSaveChanges = () => {
    // Create a deep copy of the message template list
    let tempMessageTemplateList = messageTemplateList.map((item) => ({
      ...item,
    }));

    // Process each template
    tempMessageTemplateList = tempMessageTemplateList.map((item) => {
      const isChecked =
        checkedStates && checkedStates[item.operatorMessageTemplateId];

      if (isChecked) {
        // If true, set messageViaApp to be the same as messageViaSms
        item.messageViaApp = item.messageViaSms;
      }

      // Clean up unnecessary fields
      delete item.messageTitle;
      delete item.checked;
      delete item.messageViaAppDefault;
      delete item.messageViaSmsDefault;
      delete item.variableNames;

      // Process messageMedia into comma-separated string
      item.messageMedia = item.messageMedia
        .filter((subItem) => subItem.checked === true)
        .map((subItem) => subItem.id)
        .join(",");

      return item;
    });

    // Separate templates into update and create groups
    const templatesToUpdate = tempMessageTemplateList.filter(
      (item) =>
        item.operatorMessageTemplateId !== 0 &&
        item.operatorMessageTemplateId !== "0"
    );

    const templatesToCreate = tempMessageTemplateList.filter(
      (item) =>
        (item.operatorMessageTemplateId === 0 ||
          item.operatorMessageTemplateId === "0") &&
        // Only include templates where at least one message has content
        (item.messageViaSms.trim() !== "" || item.messageViaApp.trim() !== "")
    );

    // Define operations to be performed
    const operations = [];

    // Add update operation if needed
    if (templatesToUpdate.length > 0) {
      operations.push(
        updateMessageTemplate({
          variables: {
            operatorMessageTemplateArg: templatesToUpdate,
          },
        })
      );
    }

    // Add create operation if needed
    if (templatesToCreate.length === 1) {
      // Use single create mutation for just one template
      const singleTemplate = templatesToCreate[0];
      operations.push(
        singleCreateMessageTemplate({
          variables: {
            input: {
              operatorMessageTemplateId:
                singleTemplate.operatorMessageTemplateId,
              operatorMessageTypeId: singleTemplate.operatorMessageTypeId,
              messageMedia: singleTemplate.messageMedia,
              messageViaSms: singleTemplate.messageViaSms,
              messageViaApp: singleTemplate.messageViaApp,
              operatorId: singleTemplate.operatorId,
              lockerTypeId: singleTemplate.lockerTypeId,
            },
          },
        })
      );
    } else if (templatesToCreate.length > 1) {
      // Use bulk create mutation for multiple templates
      operations.push(
        bulkCreateMessageTemplate({
          variables: {
            inputs: templatesToCreate,
          },
        })
      );
    }

    // Execute all operations with Promise.all
    Promise.all(operations)
      .then((responses) => {
        console.log("Operations completed successfully:", responses);

        // Refetch data to get updated records
        refetch({
          operatorId: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user")).operator_id
            : "",
          lockerTypeId: lockerTypeValue,
          menuGroup: "Locker Cleanup Templates",
          messageGroup: messageGroupValue,
        });

        // Show success message
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_success_title_default,
          message: Strings.popup_success_message_edit,
          open: true,
          actions: (
            <div className="grid grid-cols-1 gap-2">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  window.location.reload();
                }}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      })
      .catch((error) => {
        console.error("Error during operations:", error);

        // Show error message
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: Strings.popup_error_title,
          message: Strings.popup_error_message_edit,
          open: true,
          actions: (
            <div className="grid grid-cols-1 gap-2">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  window.location.reload();
                }}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      });
  };

  const handleCancelChanges = () => {
    setValidation({ open: false });
    console.log(messageTemplateListOriginal);
    setMessageTemplateList(messageTemplateListOriginal);
    setEditingDone(false);
    window.location.reload();
  };
  // Use Effects
  useEffect(() => {
    if (pendingNavigation !== null) {
      if (editingDone) {
        // setOpenCancelModal(true);
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, editingDone]);
  React.useEffect(() => {
    if (lockerTypes.data) {
      let tempVar = [];
      lockerTypes.data.lockerTypes.forEach((element) => {
        tempVar.push({ value: element.lockerTypeId, name: element.lockerType });
      });
      setLockerTypeList(tempVar);
    }
  }, [lockerTypes.data]);
  React.useEffect(() => {
    if (data) {
      let tempList = [];
      let tempCheckedStates = {};

      data.operatorMessageTemplates.forEach((element, id) => {
        const isChecked = element.messageViaApp === element.messageViaSms;

        let tempMessageMedia = [];
        let tempVariable = [];
        MESSAGE_MEDIA.forEach((item) => {
          tempMessageMedia.push({
            id: item,
            text: item.toUpperCase(),
            checked: element.messageMedia.split(",").find((x) => x === item)
              ? true
              : false,
          });
        });
        tempList.push({
          lockerTypeId: lockerTypeValue,
          operatorId: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user")).operator_id
            : "",
          operatorMessageTemplateId: element.operatorMessageTemplateId,
          operatorMessageTypeId:
            element.operatorMessageType.operatorMessageTypeId,
          messageViaSms: element.messageViaSms,
          messageViaApp: element.messageViaApp,
          checked: element.messageViaApp === element.messageViaSms,
          messageMedia: tempMessageMedia,
          messageTitle: element.operatorMessageType.messageTitle,
          variableNames: element.operatorMessageType.variableNames
            .split(",")
            .map((subItem) => `$${subItem}`),
          messageViaSmsDefault:
            element.operatorMessageType.messageViaSmsDefault,
          messageViaAppDefault:
            element.operatorMessageType.messageViaAppDefault,
        });
        tempCheckedStates[element.operatorMessageTemplateId] = isChecked;
      });
      console.log(tempList);
      setMessageTemplateList(tempList);
      setMessageTemplateListOriginal(tempList);
      setCheckedStates(tempCheckedStates);
    }
  }, [data]);
  return (
    <ContentContainer containerTitle={"Locker Clean-Up Template"}>
      <div className="flex gap-2">
        <p className="my-auto">Locker Type: </p>
        <Select
          items={lockerTypeList}
          defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
          value={lockerTypeValue}
          onChange={handleChangeLockerTypeValue}
        />
      </div>
      {lockerTypeValue !== "-1" && (
        <>
          {/* <Tabview
						className="my-4"
						items={[
							{
								header: "Drop-Off Alerts",
								body: (
									<TabviewTemplate
										data={messageTemplateList}
										lockerType={
											lockerTypeList.find((x) => x.value === lockerTypeValue) &&
											lockerTypeList.find((x) => x.value === lockerTypeValue)
												.name
										}
										onChange={handleOnTemplateChange}
									/>
								),
							},
							,
						]}
						activeIndex={MESSAGE_GROUP.findIndex(
							(x) => x === messageGroupValue
						)}
						onTabChanged={handleOnTabChanged}
					/> */}
          <TabviewTemplate
            disabled={
              accessPermission.lockerCleanupTemplates === "1" ||
              accessPermission.lockerCleanupTemplates === 1
            }
            checkedStates={checkedStates}
            handleCheckedChange={handleCheckedChange}
            // checked={checked}
            // setChecked={setChecked}
            data={messageTemplateList}
            lockerType={
              lockerTypeList.find((x) => x.value === lockerTypeValue) &&
              lockerTypeList.find((x) => x.value === lockerTypeValue).name
            }
            onChange={handleOnTemplateChange}
            setEditingDone={setEditingDone}
          />

          <div className={`grid grid-cols-3 gap-2 w-2/3 pb-5 pt-5`}>
            <Button
              // disabled={modifyingFlag}
              disabled={
                accessPermission.lockerCleanupTemplates === "1" ||
                accessPermission.lockerCleanupTemplates === 1
              }
              value={"Cancel"}
              className={`p-2 ${editingDone ? "" : "hidden"}`}
              onClick={() => {
                setValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                  title: Strings.popup_confirm_cancel_title,
                  message: Strings.popup_confirm_cancel_massage,
                  open: true,
                  actions: (
                    <div className="grid grid-cols-2 gap-2">
                      <Button
                        onClick={() => setValidation({ open: false })}
                        value={"No"}
                        className={"p-2 w-full"}
                      />
                      <Button
                        onClick={handleCancelChanges}
                        value={"Yes"}
                        className={"p-2 w-full"}
                      />
                    </div>
                  ),
                });
              }}
            />
            <Button
              // disabled={modifyingFlag}
              disabled={
                accessPermission.lockerCleanupTemplates === "1" ||
                accessPermission.lockerCleanupTemplates === 1
              }
              value={"Save Changes"}
              className={`p-2 ${editingDone ? "" : "hidden"}`}
              onClick={() => {
                setValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                  title: Strings.popup_confirm_save_title,
                  message: Strings.popup_confirm_save_message_with_hours,
                  open: true,
                  actions: (
                    <div className="grid grid-cols-2 gap-2">
                      <Button
                        onClick={() => setValidation({ open: false })}
                        value={"No"}
                        className={"p-2 w-full"}
                      />
                      <Button
                        onClick={handleSaveChanges}
                        value={"Yes"}
                        className={"p-2 w-full"}
                      />
                    </div>
                  ),
                });
              }}
            />
          </div>
        </>
      )}
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
